module.exports = __webpack_public_path__ + "img/mohamed.f0d6d285.jpg";